/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { errorToast, successToast } from '../helpers/toastHelper';
import { apiCreateRender } from '../helpers/api';
import styles from '../components/admin/curator/RenderPreviewsDialog/RenderPreviewDialog.module.scss';
import { RP_TYPE } from '../config/constant/unityConstants';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSiloRoom, setCuratorLoader } from '../redux/slicers/admin/curatorSlicer';
import { ProduceImageDialogUI } from '../components/admin/curator/RenderPreviewsDialog/ProduceImageDialogUI';
import {
  imagePaymentFormPopupActions,
  selectOrgAvailableBalance,
} from '../redux/slicers/imagePaymentFormPopupSlicer';
import { useUserContext } from '../contexts/UserContext';
import { selectPopupType, setOpen } from '../redux/slicers/camera/renderPreviewPoppupSlicer';
import { dispatcher } from '../helpers/projectHelper';
import { RP_STATUS } from '../constants/renderPreviewConstants';
import { createNsetClientSecretKey } from '../components/admin/curator/RenderPreviewsDialog/PaymentFormForImages';

export default function RenderPageDialog({
  renderId,
  renderName,
  renderExtension,
  isMetaData,
  isWatermark,
  isImageWatermark,
  isPaidLicense,
  isShadowOnFloor,
  isTransparentBg,
  cameraData,
  showRender,
  setShowRender,
  hasMetadata,
  onRenderSuccess,
}) {
  const dispatch = useDispatch();
  const { updateUserData } = useUserContext();
  const [cameraList, setCameraList] = useState(cameraData);
  const [loading, setLoading] = useState(false);
  const isSiloRoom = useSelector(selectIsSiloRoom);
  const popupType = useSelector(selectPopupType);
  const { freeCredits, isFreemiumUser, isFreemiumOrOldSubscriptionUser, isPremiumUser } =
    useUserContext();
  const isMyOrgHasBalance = useSelector(selectOrgAvailableBalance);
  const isBalanceAvailableOrPremiumUser = isMyOrgHasBalance > 0 || isPremiumUser();
  const isCreditsAvailable = Number(freeCredits) > 0;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    handlePopup();
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!popupType && isMounted) {
      setShowRender(false);
      handlePopup();
    }
  }, [popupType, isMounted]);

  const handlePopup = () => {
    dispatch(setOpen(RP_TYPE.RENDER));
  };

  const handleSaveRenderPreview = async (values, selectedCameraIds, resetValues, callback) => {
    setLoading(false);
    dispatch(setCuratorLoader(true));
    dispatch(imagePaymentFormPopupActions.close());
    const selectedCameraList = cameraList.filter((c) => selectedCameraIds?.includes(c.id));
    if (!values.name && !values.is_free_credit_use) {
      errorToast('Please enter a file name.');
      return;
    }
    if (values.is_free_credit_use && selectedCameraList.length > freeCredits) {
      errorToast(`You can't select more than ${freeCredits} camera.`);
      return;
    }
    if (!selectedCameraList.length) {
      errorToast('Please add at least one camera');
      return;
    }
    setLoading(true);
    const renderCamList = selectedCameraList?.map((a) => {
      return {
        id: a.id,
        resoX: a.resoX,
        resoY: a.resoY,
        dpi: values.dpi,
      };
    });
    const payload = {
      count: selectedCameraList.length,
      render_name: values.name || renderName,
      render_extension: values.imageType || renderExtension,
      render_camera: JSON.stringify(renderCamList),
      render_id: renderId,
      is_meta_data: values.metadata || isMetaData,
      is_shadow_on_floor: values.shadowOnFloor || isShadowOnFloor,
      is_transparent_bg: values.transparentBg || isTransparentBg,
      is_water_mark: values.watermark || isWatermark,
      ...('is_free_credit_use' in values && { is_free_credit_use: values.is_free_credit_use }),
      ...('is_stripe_payment' in values && { is_stripe_payment: values.is_stripe_payment }),
      ...('partial_stripe_payment' in values && {
        partial_stripe_payment: values.partial_stripe_payment,
      }),
      ...('partial_credit_amount' in values && {
        partial_credit_amount: values.partial_credit_amount,
      }),
    };
    const res = await apiCreateRender(payload);
    if (res) {
      if (res.status) {
        const mainRenderId = res?.data?.id;
        if (values.is_stripe_payment && res?.data?.status === RP_STATUS.STATUS_DISABLED) {
          dispatcher(imagePaymentFormPopupActions.setDisabledRenderJobId(mainRenderId));
          await createNsetClientSecretKey();
          dispatcher(imagePaymentFormPopupActions.show());
          setLoading(false);
          return;
        }
        updateUserData();
        successToast(res?.message !== '' ? res?.message : 'Your image is being processed');
        onRenderSuccess && onRenderSuccess(res.data);
        callback && callback();
        if (!callback) setShowRender(false);
        if (!callback) setLoading(false);
      } else {
        errorToast(res?.message);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const updateCamera = (cameraId, data) => {
    const updatedCameraList = cameraList.map((camera) => {
      if (camera.id === cameraId) {
        return {
          ...camera,
          ...data,
        };
      }
      return camera;
    });
    setCameraList(updatedCameraList);
  };

  const handleResolutionChange = (resoX, resoY, cameraId) => {
    updateCamera(cameraId, { resoX, resoY });
  };

  const handleLockToggle = (cameraId) => {
    const camera = cameraList.find((c) => c.id === cameraId);
    updateCamera(cameraId, { is_lock: !camera.is_lock });
  };

  const handleCameraClick = (camera) => {
    console.log('camera: ', camera);
  };

  return (
    <ProduceImageDialogUI
      dialogClassName={styles.renderPopupBottom}
      show={true}
      popupType={popupType}
      onClose={() => setShowRender(false)}
      cameraList={cameraList}
      onCameraResolutionChange={handleResolutionChange}
      onSubmit={handleSaveRenderPreview}
      setLoading={setLoading}
      onCameraClick={handleCameraClick}
      loading={loading}
      onLockToggle={handleLockToggle}
      isSiloRoom={isSiloRoom}
      hasMetadata={hasMetadata}
      lockedRatio
      showLicenseTab={true}
      hideFreeLicenseView={isBalanceAvailableOrPremiumUser || (!isImageWatermark && !isPaidLicense)}
      isCreditsAvailable={isCreditsAvailable}
    />
  );
}
